module.exports = __webpack_public_path__ + "images/components/estimate_banners/link_with_image/products_left_pc_68f2a37c43a44541042cab1008de42c1.svg";